<template>
  <div class="content">
    <div class="bodycontent">
      <el-form :model="formData" ref="formData" label-width="180px" :rules="rules">
        <el-form-item label="选择商品" prop="goodsname">
          <el-input v-model="goodsname" class="input_box" readonly>
            <el-button type="primary" slot="append" @click="showSelecter = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="用户头像">
          <el-upload
            ref="upload"
            class="avatar-uploader"
            action="https://www.58zltc.com/api/Upload/uploads/"
            :show-file-list="false"
            accept="image/*"
            :on-success="handleAvatarSuccess"
            :data="imgdata"
            :on-change="changefile"
            :auto-upload="false"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="用户昵称" prop="username">
          <el-input v-model="formData.username" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="评分等级">
          <el-rate v-model="formData.score" style="margin-top:10px;"></el-rate>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-radio-group v-model="formData.show">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 首次评论 -->
        <el-form-item label="首次评论" class="mb10" prop="content">
          <el-input type="textarea" rows="3" class="input_box" v-model="formData.content"></el-input>
        <!-- 评论时间 -->
        </el-form-item>
        <el-form-item class="mb10" prop="create_time">
          <el-date-picker
            v-model="formData.create_time"
            type="datetime"
            placeholder="选择首次评论日期时间">
          </el-date-picker>
        </el-form-item>
        <!-- 评论图片 -->
        <el-form-item>
          <el-upload
            list-type="picture-card"
            accept="image/*"
            action="#"
            :http-request="(file)=> { return productUploadImg(file,1) }"
            :on-remove="(file)=>handleRemove(file,1)"
            :file-list="fileListData1">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <!-- 首次回复 -->
        <el-form-item label="首次回复" class="mb10">
          <el-input type="textarea" rows="3" class="input_box" v-model="formData.reply_content"></el-input>
        </el-form-item>
        <!-- 评论时间 -->
        <el-form-item class="mb10">  
          <el-date-picker
            v-model="time2"
            type="datetime"
            placeholder="选择首次回复日期时间">
          </el-date-picker>
        </el-form-item>
        <!-- 评论图片 -->
        <el-form-item>
          <el-upload
            list-type="picture-card"
            accept="image/*"
            action="#"
            :http-request="(file)=> { return productUploadImg(file,2) }"
            :on-remove="(file)=>handleRemove(file,2)"
            :file-list="fileListData2">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <!-- 追加评价 -->
        <el-form-item label="追加评价">
          <el-input type="textarea" rows="3" class="input_box mb10" v-model="formData.re_content"></el-input>
          <!-- 评论时间 -->
          <div class="mb10">
            <el-date-picker
              v-model="time3"
              type="datetime"
              placeholder="选择追加评论日期时间">
            </el-date-picker>
          </div>
          <!-- 评论图片 -->
          <el-upload
            list-type="picture-card"
            accept="image/*"
            action="#"
            :http-request="(file)=> { return productUploadImg(file,3) }"
            :on-remove="(file)=>handleRemove(file,3)"
            :file-list="fileListData3">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <!-- 追加回复 -->
        <el-form-item label="追加回复">
          <el-input type="textarea" rows="3" class="input_box mb10" v-model="formData.re_reply_content"></el-input>
          <!-- 评论时间 -->
          <div class="mb10">
            <el-date-picker
              v-model="time4"
              type="datetime"
              placeholder="选择追加回复日期时间">
            </el-date-picker>
          </div>
          <!-- 评论图片 -->
          <el-upload
            list-type="picture-card"
            accept="image/*"
            action="#"
            :http-request="(file)=> { return productUploadImg(file,4) }"
            :on-remove="(file)=>handleRemove(file,4)"
            :file-list="fileListData4">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button @click="goback()">返回列表</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity @close="showSelecter = false" @getCommod="getCommod"></selectCommodity>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AddComment, addImage } from "@/api/comment";
import selectCommodity from "@/components/commodity/selectCommodity2.vue";
export default {
  components:{
    selectCommodity
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  },
  data() {
    return {
      formData: {},
      create_time: "", //创建时间
      time2: "", //回复时间
      time3: "", //追评时间
      time4: "", //追评回复时间
      goodsname: "", //商品名称
      showSelecter: false, //商品选择器
      imageUrl: "", //上传的图片地址
      imgdata: {}, //上传图片附加信息
      image_id: "", //上传后服务器路径
      if_add: true, // 新建/修改
      //首次评价
      chosepictireid1:[], //已上传图片id数组暂存
      fakefileList1: [], //假的filelist列表
      fileListData1:[], //filelist列表
      //首次回复
      chosepictireid2:[], //已上传图片id数组暂存
      fakefileList2: [], //假的filelist列表
      fileListData2:[], //filelist列表
      //追加评价
      chosepictireid3:[], //已上传图片id数组暂存
      fakefileList3: [], //假的filelist列表
      fileListData3:[], //filelist列表
      //追加回复
      chosepictireid4:[], //已上传图片id数组暂存
      fakefileList4: [], //假的filelist列表
      fileListData4:[], //filelist列表
      if_add: true, //是否是新建评论
      rules: {
        goodsname: [
          { required: true, message: "请选择商品", trigger: "submit" }
        ],
        username: [
          { required: true, message: "请输入用户昵称", trigger: "blur" }
        ],
        content: [
          { required: true, message: "请输入评价内容", trigger: "blur" }
        ],
        create_time: [
          { required: true, message: "请选择评价时间", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    init() {
      var data = this.$route.query.item || "";
      console.log(data);
      if(data){
        this.if_add = false;
      }
      this.formData = {
        goods_id: "",
        create_time: "",
        headimg: "",
        username: "",
        score: 0,
        show: "1",
        content: "",
        images: "",
        reply_content: "",
        reply_images: "",
        reply_time: "",
        re_content: "",
        re_images: "",
        re_content_time: "",
        re_reply_content: "",
        re_reply_images: "",
        re_reply_time: ""
      }
      // this.imageUrl = data.headimg;
    },
    submit() {
      if (this.imageUrl != "") {
        console.log(this.$refs.upload.data)
        this.$refs.upload.submit();
      }else {
        this.$message({
          type:"warning",
          message:"请上传用户头像"
        })
      }
    },
    //商品选择器
    getCommod(data){
      this.formData.goods_id = data.id;
      this.goodsname = data.name;
    },
    // 图片上传
    // 文件选取的时候调用
    changefile(file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      console.log(file, fileList);
      this.imgdata = {
        token: this.token,
        image: file.raw,
        type: "1",
        file_group: "1"
      };
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.formData.headimg = res.data.id;
      this.save();
    },
    //上传评论图片
    productUploadImg(file,i){
      console.log(file)
      var that = this;
      var formdata = new FormData();
      formdata.append('token', that.token);
      formdata.append('image', file.file);
      formdata.append('type', "1");
      formdata.append('file_group', "1");
      addImage(formdata).then(res => {
        console.log("上传回调",res);
        var data = res.data;
        if(res.code == 200){
          if(i == 1){
            this.chosepictireid1.push(res.data.id);
            this.formData.images = this.chosepictireid1.join(',');
            var list = {};
            list.name = res.data.key;
            list.url = res.data.url;
            list.uid = file.file.uid;
            this.fakefileList1.push(list);
          }else if(i == 2){
            this.chosepictireid2.push(res.data.id);
            this.formData.reply_images = this.chosepictireid2.join(',');
            var list = {};
            list.name = res.data.key;
            list.url = res.data.url;
            list.uid = file.file.uid;
            this.fakefileList2.push(list);
          }else if(i == 3){
            this.chosepictireid3.push(res.data.id);
            this.formData.re_images = this.chosepictireid3.join(',');
            var list = {};
            list.name = res.data.key;
            list.url = res.data.url;
            list.uid = file.file.uid;
            this.fakefileList3.push(list);
          }else if(i == 4){
            this.chosepictireid4.push(res.data.id);
            this.formData.re_reply_images = this.chosepictireid4.join(',');
            var list = {};
            list.name = res.data.key;
            list.url = res.data.url;
            list.uid = file.file.uid;
            this.fakefileList4.push(list);
          }else if(i == 5){
            this.imageUrl = res.data.url;
            this.formData.headimg = res.data.id;
          }
        } else{
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },  
    // 删除评论图片
    handleRemove(file,index) {
      console.log(file)
      var replaceArr = [];
      if(index == 1){
        replaceArr = this.fakefileList1;
      }else if(index == 2){
        replaceArr = this.fakefileList2;
      }else if(index == 3){
        replaceArr = this.fakefileList3;
      }else if(index == 4){
        replaceArr = this.fakefileList4;
      }
      console.log(replaceArr)
      for(var i= 0; i < replaceArr.length; i++){
        if(file.uid == replaceArr[i].uid){
          replaceArr.splice(i,1);
          if(index == 1){
            this.chosepictireid1.splice(i,1);
            this.formData.images = this.chosepictireid1.join(',');
            console.log(this.formData.images ,"delete list1 item");
          }else if(index == 2){
            this.chosepictireid2.splice(i,1);
            this.formData.reply_images = this.chosepictireid2.join(',');
            console.log(this.formData.reply_images ,"delete list2 item");
          }else if(index == 3){
            this.chosepictireid3.splice(i,1);
            this.formData.re_images = this.chosepictireid3.join(',');
            console.log(this.formData.re_images ,"delete list3 item");
          }else if(index == 4){
            this.chosepictireid4.splice(i,1);
            this.formData.re_reply_images = this.chosepictireid4.join(',');
            console.log(this.formData.re_reply_images ,"delete list4 item");
          }
          break;
        }
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
    },
    //保存表单
    save() {
      var data = Object.assign({}, this.formData);
      data.create_time = this.formData.create_time == ""? "":this.formatTime(this.formData.create_time);
      data.reply_time = this.time2 == ""? "":this.formatTime(this.time2);
      data.re_content_time = this.time3 == ""? "":this.formatTime(this.time3);
      data.re_reply_time = this.time4 == ""? "":this.formatTime(this.time4);
      data.token = this.token;
      data.app_id = this.app_id;
      console.log('data:',data);
      this.$refs['formData'].validate((valid)=>{
        if(valid){
          AddComment(data).then(res => {
            if (res.code == "200") {
              this.$message({
                type: "success",
                message: res.msg
              });
              this.$router.go(-1);
            }else{
              this.$message({
                type:"error",
                message: res.msg
              })
            }
          });
        }else{
          console.log('error submit!!');
          return false;
        }
      })
    },
    //返回列表
    goback(){
      this.$router.go(-1);
    },
    //时间格式化
    formatTime(time){
      var t = new Date(time*1000);
      var y = t.getFullYear();
      var m = t.getMonth() + 1;
      var d = t.getDate();
      var h = t.getHours();
      var mm = t.getMinutes();
      var s = t.getSeconds();
      m = m < 10? '0'+m : m;
      d = d < 10? '0'+d : d;
      mm = mm < 10? '0'+mm : mm;
      s = s < 10? '0'+s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s;
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.el-upload-list--picture-card .el-upload-list__item {
  height: 90px;
  width: 90px;
}
.el-upload--picture-card {
  height: 90px;
  width: 90px;
  line-height: 100px;
}
</style>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  font-size: 14px;
  .bodycontent{
    padding: 27px 0;
    height: 96%;
    overflow: auto;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
    // 图片上传
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 70px;
      height: 70px;
      line-height: 70px;
      text-align: center;
    }
    .avatar {
      width: 70px;
      height: 70px;
      display: block;
    }
    .el-upload-list__item{
      width:90px;
      height: 90px;
    }
    //input输入框
    .input_box{
      width: 450px;
    }
    .mb10{
      margin-bottom: 10px;
    }
  }
}
</style>
